import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "waybills-table-column-courier-payment-rate-type" }
const _hoisted_2 = { class: "container__title" }
const _hoisted_3 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "12",
  cy: "12",
  r: "10"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("polyline", { points: "12 6 12 12 16 14" }, null, -1)
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("rect", {
  width: "20",
  height: "12",
  x: "2",
  y: "6",
  rx: "2"
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "12",
  cy: "12",
  r: "2"
}, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("path", { d: "M6 12h.01M18 12h.01" }, null, -1)
const _hoisted_11 = [
  _hoisted_8,
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = {
  key: 2,
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("path", { d: "M2.586 16.726A2 2 0 0 1 2 15.312V8.688a2 2 0 0 1 .586-1.414l4.688-4.688A2 2 0 0 1 8.688 2h6.624a2 2 0 0 1 1.414.586l4.688 4.688A2 2 0 0 1 22 8.688v6.624a2 2 0 0 1-.586 1.414l-4.688 4.688a2 2 0 0 1-1.414.586H8.688a2 2 0 0 1-1.414-.586z" }, null, -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = {
  key: 3,
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("path", { d: "M8 2v4" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("path", { d: "M16 2v4" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("rect", {
  width: "18",
  height: "18",
  x: "3",
  y: "4",
  rx: "2"
}, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("path", { d: "M3 10h18" }, null, -1)
const _hoisted_20 = [
  _hoisted_16,
  _hoisted_17,
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = { class: "container__amount" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.courier && _ctx.courier.paymentRateType)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["waybills-table-column-courier-payment-rate-type__container", {
                'container--hour': _ctx.courier.paymentRateType.id === 1,
                'container--trip': _ctx.courier.paymentRateType.id === 2,
                'container--stop': _ctx.courier.paymentRateType.id === 3,
                'container--day': _ctx.courier.paymentRateType.id === 4
            }])
        }, [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.courier.paymentRateType.id === 1)
              ? (_openBlock(), _createElementBlock("svg", _hoisted_3, _hoisted_6))
              : (_ctx.courier.paymentRateType.id === 2)
                ? (_openBlock(), _createElementBlock("svg", _hoisted_7, _hoisted_11))
                : (_ctx.courier.paymentRateType.id === 3)
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_12, _hoisted_14))
                  : (_ctx.courier.paymentRateType.id === 4)
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_15, _hoisted_20))
                    : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(_ctx.courier.paymentRateType.title), 1)
          ]),
          _createElementVNode("div", _hoisted_21, [
            (_ctx.courier.paymentRateType.id === 1)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_ctx.formatPriceToTenge(_ctx.courier.paymentAmount, { withDecimals: true })) + "/ч ", 1)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(_ctx.formatPriceToTenge(_ctx.courier.paymentAmount, { withDecimals: true })), 1)
                ], 64))
          ])
        ], 2))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createTextVNode(" — ")
        ], 64))
  ]))
}